import md5 from "md5";

/**
 * Generate Gravatar URL from email
 */
export function getUserAvatarUrl(
  email: string,
  size: number = 80,
  defaultImage: string = "mp",
): string {
  if (!email || typeof email !== "string") {
    return `https://www.gravatar.com/avatar/00000000000000000000000000000000?s=${size}&d=${defaultImage}`;
  }

  const normalizedEmail = email.trim().toLowerCase();
  const hash = md5(normalizedEmail);

  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=${defaultImage}`;
}

/**
 * Async version of getUserAvatarUrl with proper Gravatar detection
 */
export async function getUserAvatarUrlAsync(
  email: string,
  customAvatarUrl?: string | null,
  size: number = 80,
): Promise<string | null> {
  // Если есть кастомный аватар, используем его
  if (customAvatarUrl) {
    return customAvatarUrl;
  }

  if (!email || typeof email !== "string") {
    return null; // Нет email — пусть компонент покажет инициалы/иконку
  }

  // В браузере нельзя надёжно проверить наличие Gravatar через HEAD из-за CORS.
  // Возвращаем прямой URL с fallback "mp" (mystery person silhouette) — если нет реального аватара,
  // Gravatar отдаст силуэт пользователя.
  const normalizedEmail = email.trim().toLowerCase();
  const hash = md5(normalizedEmail);
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=mp`;
}

/**
 * Check if Gravatar exists for email
 */
export async function checkGravatarExists(_email: string): Promise<boolean> {
  // В браузере этот метод ненадёжен из‑за CORS и оставлен только для обратной совместимости.
  // Всегда возвращаем false, чтобы не блокировать показ аватара.
  // Если понадобится серверная проверка — используйте backend util.
  return false;
}

/**
 * Get user initials for fallback avatar
 */
export function getUserInitials(name?: string, email?: string): string {
  if (name) {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  }

  if (email) {
    return email[0].toUpperCase();
  }

  return "?";
}
